/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const styles = (theme) => {
    const { typography, breakpoints: { minWidth, maxWidth }, palette } = theme;
    return {
        bgsSlider: {
            '&.bgsSliderWrapper': {
                marginBottom: '30px',
                '& .relative': {
                    position: 'relative',
                },
                '& .sliderTitle h2': {
                    fontWeight: typography?.font_weight_semi_bold,
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    fontFamily: 'BebasNeue',
                    margin: '0 0 0.5rem',
                    fontSize: '2rem',
                },
                '& .slick-track': {
                    display: 'flex',
                },
                '& .slider-container': {
                    '& .slick-dots': {
                        '& li button:before': {
                            width: '12px',
                            border: '1px solid #000',
                            height: '12px',
                            content: '""',
                            fontSize: '1.25rem',
                            borderRadius: '50%',
                        },
                        '& li.slick-active button:before': {
                            opacity: '.75',
                        },
                    },
                },
                '& .slick-dots': {
                    bottom: '0px',
                    textAlign: 'center',
                    '& li': {
                        width: '12px',
                        height: '12px',
                        position: 'relative',
                        display: 'inline-block',
                        margin: '0 5px',
                        padding: '0',
                    },
                    '& li button': {
                        color: 'transparent',
                        background: 'transparent',
                        border: '0',
                        lineHeight: '0',
                        fontSize: '0',
                        outline: 'none',
                        padding: '5px',
                        display: 'block',
                    },
                    '& li button:before': {
                        fontFamily: 'slick',
                        textAlign: 'center',
                        '-webkit-font-smoothing': 'antialiased',
                        top: '0',
                        bottom: '0',
                        position: 'absolute',
                        lineHeight: '20px',
                        opacity: '.25',
                    },
                },
                '& a': {
                    textDecoration: 'none',
                },
                '& .bgsTitle': {
                    width: '100% !important',
                    textTransform: 'uppercase',
                    textAlign: 'center !important',
                },
                '& .bgsPrice': {
                    display: 'none',
                },
            },
            '&.bgs-slider-wrapper': {
                '& .slick-dots': {
                    display: 'block',
                    bottom: '0!important',
                    paddingBottom: '0!important',
                    transform: 'translate(-5px, 12px)!important',
                    position: 'absolute',
                    width: '100%',
                    padding: '0',
                    margin: '0',
                    listStyle: 'none',
                    textAlign: 'center',
                },
                '& .slick-active': {
                    paddingLeft: '0!important',
                },
            },
            '& .slick-list': {
                overflow: 'hidden',
            },
        },
        BGSContactFormStyles: {
            '&.bgsContainer': {
                maxWidth: '1270px',
                paddingLeft: '15px',
                paddingRight: '15px',
                [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                    maxWidth: '720px',
                },
                '& article.bgs-banner.wrapper img': {
                    minHeight: '386px',
                },
                '& .contactUsForm': {
                    padding: '80px',
                    backgroundColor: palette?.bgs_grey,
                    marginBottom: '40px',
                    position: 'relative',
                    marginLeft: '-15px',
                    marginRight: '-15px',
                    '& h1': {
                        fontSize: typography?.font_size_lg_bgs_title,
                        fontWeight: typography?.font_weight_semi_bold,
                        textTransform: 'uppercase',
                        fontFamily: typography?.secondaryFontFamily,
                        marginBottom: '0.5rem',
                        marginTop: 0,
                        lineHeight: '38px',
                        paddingLeft: '15px',
                    },
                    '& .m-0': {
                        margin: 0,
                    },
                    '& p': {
                        [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                            maxWidth: '220px',
                        },
                    },
                    '& .bgsContactForm': {
                        '& .subTitle': {
                            paddingLeft: '15px',
                        },
                        '& .delieryAddress-article': {
                            display: 'flex',
                            '& .multiple_delivery_0_element': {
                                order: '2',
                            },
                        },
                        '& .contactTitle': {
                            fontWeight: typography.font_weight_bold,
                            paddingTop: '35px',
                            fontSize: '1.5rem',
                            fontFamily: typography?.fontFamily,
                            lineHeight: '1.2',
                            marginBottom: '1rem',
                            paddingLeft: '15px',
                            [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                                paddingTop: '30px',
                            },
                        },
                        '& .bgsInputElement': {
                            paddingBottom: '15px',
                            paddingLeft: '15px',
                            paddingRight: '15px',
                            marginBottom: '1.5rem',
                            width: '100%',
                            [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                                '&.single_delivery_element': {
                                    paddingBottom: '0',
                                },
                            },
                            [theme.breakpoints.up(minWidth?.medium_screen_down)]: {
                                '&:nth-of-type(even)': {
                                    paddingLeft: '20px !important',
                                },
                            },
                            '&.delivery_date_element': {
                                '& .MuiInputBase-root': {
                                    border: 'none',
                                },
                            },
                        },
                        [theme.breakpoints.up(minWidth?.small_screen_down)]: {
                            '& .firstname_element, .email_element, .location_element, .city_element, .orderquantity_element': {
                                '& input': {
                                    borderRight: '0px',
                                },
                            },
                        },
                        '& button.sendOrderRequest': {
                            backgroundColor: palette?.bgs_radio_green,
                            width: '345px',
                            cursor: 'pointer',
                            height: '69px',
                            textAlign: 'center',
                            color: palette?.common?.white,
                            textTransform: 'uppercase',
                            border: '1px solid transparent',
                            borderRadius: '0',
                            fontSize: '1.125rem',
                            lineHeight: '1.5rem',
                            fontWeight: typography.font_weight_regular,
                            [theme.breakpoints.up(maxWidth?.small_screen_down)]: {
                                marginLeft: '15px',
                            },
                            [theme.breakpoints.down(maxWidth?.small_screen_down)]: {
                                width: '100%',
                            },
                        },
                        '& .addressRemoveCircle': {
                            transform: 'translateY(3px)',
                            cursor: 'pointer',
                        },
                    },
                    [theme.breakpoints.down(maxWidth?.small_screen_down)]: {
                        padding: '29px',
                    },
                    '& .addMore': {
                        display: 'flex',
                        alignItems: 'center',
                        margin: '10px 0px',
                        fontSize: typography.font_size_md,
                        fontWeight: typography.font_weight_bolder,
                        cursor: 'pointer',
                        '& .materialAdd': {
                            fontSize: typography.font_size_md,
                            fontWeight: typography.font_weight_bolder,
                            transform: 'translateY(-2px)',
                        },
                    },
                    '& .orderArticle': {
                        position: 'relative',
                        '& .delivery_date_element': {
                            '& .MuiInputBase-root': {
                                display: 'flex',
                                width: '100%',
                                height: 'calc(2.05em + 0.75rem + 2px)',
                                padding: '0',
                                fontFamily: typography?.font_family_base,
                                fontSize: typography?.font_size_base,
                                fontWeight: typography?.font_weight_normal,
                                lineHeight: typography?.line_height_base,
                                color: palette?.gray_700,
                                backgroundColor: palette?.common?.white,
                                backgroundClip: 'padding-box',
                                border: `1px solid ${palette?.common?.gray_700}`,
                                borderRadius: '0',
                                transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                            },
                        },
                    },
                },
                '& .radioTitle': {
                    color: palette?.common?.black,
                    [theme.breakpoints.up(minWidth?.small_screen_down)]: {
                        '&.desktopButton': {
                            position: 'absolute',
                            left: '52%',
                        },
                        '&.mobile-button': {
                            display: 'none',
                        },
                    },
                    [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                        '&.desktopButton': {
                            position: 'absolute',
                            top: '18%',
                            paddingLeft: '15px',
                            paddingRight: '10px',
                        },
                    },
                },
            },
        },
        bgsBulkOrder: {
            '&.bgsBulkOrderWrapper': {
                '& .bgs-bulk-order-inner-wrapper': {
                    margin: '0 auto',
                    padding: '40px 0',
                    [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                        padding: '25px 0',
                    },
                    [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                        borderBottom: 'none',
                        padding: '25px 35px',
                    },
                    '& p': {
                        width: '78%',
                        margin: '0 auto',
                        fontSize: typography.font_size_md,
                        padding: '0 25px',
                        [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                            width: '100%',
                            padding: '0 20px',
                            fontSize: typography.font_size_base,
                            lineHeight: '22px',
                        },
                        [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                            borderBottom: `1px solid ${palette?.common?.gray_700}`,
                            padding: 0,
                            paddingBottom: '40px',
                        },
                        '& h2': {
                            fontWeight: typography.font_weight_semi_bold,
                            paddingBottom: '5px',
                            [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                                fontSize: typography.font_size_xlg,
                                maxWidth: '240px',
                                margin: '0 auto',
                            },
                        },
                    },
                },
            },
        },
    };
};

export default styles;
